import { useTranslation } from 'react-i18next';

import DatePicker from '../../../../components/HookFormControls/Datepicker';
import { i18nNS } from '../../../../i18n';
import { dateToUnix, unix, unixToDate } from '../../../../utils/datetime';
import useSelectStartDateVM, { VMProps } from './vm';

interface Props extends VMProps {
  className?: string;
  disabled?: boolean;
  helperText?: string;
}

const SelectStartDate = ({ className, disabled, helperText, ...vmProps }: Props) => {
  const { t } = useTranslation([i18nNS.CREATE_COURSE]);
  const { control, controlName, setStartDate } = useSelectStartDateVM(vmProps);

  return (
    <DatePicker
      required
      fullWidth
      className={className}
      minDate={unix()}
      control={control}
      disabled={disabled}
      name={controlName}
      parser={unixToDate}
      formatter={dateToUnix}
      onChange={setStartDate}
      inputFormat="MMM dd, yyyy"
      label={t('start_date', { ns: i18nNS.COURSES })}
      helperText={helperText}
    />
  );
};
export default SelectStartDate;
